import { FaTimes } from "react-icons/fa";
import styled, { css } from "styled-components";
import { colors, font, radius, shadow } from "../../../styles/theme/tokens";

export const Wrapper = styled.div`
   padding: 15px 0px 0px 0px;
   font-family: ${font.text};
`

export const List = styled.ul`
   display: flex;
   flex-direction: column;
   gap: 10px;
   max-width: 720px;
`

export const Item = styled.li`
   display: flex;
`

// Стан дня: скасовано → перенесено → є урок → без уроку
const dayState = (props) => {
   if (props.isCanceled) return "canceled";
   if (props.isReschedule) return "reschedule";
   if (props.isSchedule) return "lesson";
   return "empty";
};

const ACCENTS = {
   lesson: colors.brand,
   reschedule: colors.amber,
   canceled: colors.danger,
   empty: "transparent",
};

export const BoxWrapper = styled.div`
   display: flex;
   align-items: center;
   gap: 12px;
   width: 100%;
   min-height: 64px;
   padding: 14px 18px 14px 20px;
   border-radius: ${radius.lg};
   border: 1px solid ${colors.line};
   border-left: 5px solid ${(props) => ACCENTS[dayState(props)]};
   background: ${colors.surface};
   box-shadow: ${shadow.card};
   transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;

   ${(props) => {
      const state = dayState(props);
      if (state === "empty") return css`
         background: transparent;
         box-shadow: none;
         border-style: dashed;
         border-left: 1px dashed ${colors.line};
         padding-left: 24px;
      `;
      if (state === "canceled") return css`
         opacity: 0.7;
      `;
      return css`
         cursor: pointer;

         &:hover {
            transform: translateY(-2px);
            box-shadow: ${shadow.raised};
         }
      `;
   }}

   ${(props) => props.isItemOpen && css`
      background: ${colors.brandSoft};
      border-color: ${colors.brand};
   `}
`

export const Day = styled.p`
   order: 0;
   flex: 1;
   font-family: ${font.text};
   font-size: 17px;
   font-weight: 700;
   color: ${colors.ink};
`

export const Time = styled.p`
   order: 2;
   font-family: ${font.text};
   font-size: 16px;
   font-weight: 800;
   font-variant-numeric: tabular-nums;
   color: ${colors.brandDeep};

   &:not(:empty) {
      padding: 6px 12px;
      border-radius: ${radius.pill};
      background: ${colors.brandSoft};
   }
`

export const NoLesson = styled.span`
   order: 2;
   font-family: ${font.text};
   font-size: 14px;
   font-weight: 600;
   color: ${colors.muted};
`

export const RescheduleText = styled.p`
   order: 1;
   padding: 5px 10px;
   border-radius: ${radius.pill};
   font-family: ${font.text};
   font-size: 12px;
   font-weight: 700;
   color: ${(props) => (props.isCanceled ? colors.danger : colors.amberDeep)};
   background: ${(props) => (props.isCanceled ? colors.dangerSoft : colors.amberSoft)};
`

// Вікно уроку: по центру екрана, фон затемнюємо великою тінню
export const ConnectWrapper = styled.div`
   position: fixed;
   top: 50%;
   left: 50%;
   z-index: 100;
   display: flex;
   flex-direction: column;
   align-items: stretch;
   gap: 10px;
   width: min(92vw, 400px);
   padding: 44px 24px 20px;
   border-radius: ${radius.xl};
   background: ${colors.surface};
   box-shadow: ${shadow.raised}, 0 0 0 100vmax rgba(30, 27, 58, 0.45);
   transform: translate(-50%, -50%) scale(${(props) => (props.isItemOpen ? 1 : 0.96)});
   transition: opacity 0.2s ease, visibility 0.2s ease, transform 0.2s ease;
   opacity: ${(props) => (props.isItemOpen ? 1 : 0)};
   visibility: ${(props) => (props.isItemOpen ? "visible" : "hidden")};
   pointer-events: ${(props) => (props.isItemOpen ? "auto" : "none")};
`

export const CloseButton = styled(FaTimes)`
   position: absolute;
   top: 16px;
   right: 16px;
   width: 32px;
   height: 32px;
   padding: 9px;
   border-radius: ${radius.pill};
   color: ${colors.muted};
   background: ${colors.bg};
   cursor: pointer;
`

const buttonBase = css`
   display: flex;
   align-items: center;
   justify-content: center;
   gap: 10px;
   width: 100%;
   padding: 13px 20px;
   border-radius: ${radius.md};
   font-family: ${font.text};
   font-size: 16px;
   font-weight: 800;
   text-decoration: none;
   cursor: pointer;
   transition: transform 0.08s ease, box-shadow 0.08s ease, background 0.15s ease;
`

export const connectLink = styled.a`
   ${buttonBase};
   color: #FFFFFF;
   background: ${colors.brand};
   box-shadow: ${shadow.button(colors.brandDeep)};

   &:active {
      transform: translateY(3px);
      box-shadow: ${shadow.button("transparent")};
   }
`

export const cancelLesson = styled.button`
   ${buttonBase};
   font-weight: 700;
   color: ${colors.muted};
   background: ${colors.bg};

   &:hover {
      color: ${colors.danger};
      background: ${colors.dangerSoft};
   }
`

export const FormWrapper = styled.div`
   display: flex;
   flex-direction: column;
   gap: 10px;
   margin-top: 6px;
   padding-top: 16px;
   border-top: 1px solid ${colors.line};
`

export const FormTitle = styled.p`
   font-family: ${font.text};
   font-size: 15px;
   font-weight: 600;
   line-height: 1.45;
   text-align: center;
   color: ${colors.ink};
`

export const CheckboxWrapper = styled.div`
   display: flex;
   align-items: center;
   gap: 12px;
   padding: 12px 14px;
   border-radius: ${radius.md};
   border: 1.5px solid ${colors.line};
   cursor: pointer;
`

export const Input = styled.input.attrs({ type: 'radio' })`
   appearance: none;
   width: 20px;
   height: 20px;
   flex-shrink: 0;
   margin: 0;
   border-radius: 50%;
   border: 2px solid ${(props) => (props.isChecked ? colors.brand : colors.line)};
   background: ${(props) => (props.isChecked ? colors.brand : colors.surface)};
   box-shadow: inset 0 0 0 3px ${colors.surface};
   cursor: pointer;
`

export const Label = styled.label`
   font-family: ${font.text};
   font-size: 15px;
   font-weight: 600;
   color: ${colors.ink};
   cursor: pointer;
`

export const SubmitButton = styled.button`
   ${buttonBase};
   color: #FFFFFF;
   background: ${colors.brand};
   box-shadow: ${shadow.button(colors.brandDeep)};

   &:active {
      transform: translateY(3px);
      box-shadow: ${shadow.button("transparent")};
   }
`

export const PopupTitle = styled.h3`
   margin-bottom: 8px;
   font-family: ${font.text};
   font-size: 20px;
   font-weight: 800;
   text-align: center;
   color: ${colors.ink};

   span {
      color: ${colors.brandDeep};
   }
`
